//For now do not see any need to use $store to hold functions (no cross component data), using global functions

function indexOfProd(prod, products) {
	return products.findIndex((item) => item.product.id == prod.id)
}

function removeProduct(prod, products) {
	var item_index = indexOfProd(prod, products)
	products.splice(item_index, 1)
}

function totalCost(products) {
	return products.reduce((accum, current) => {
		return accum + current.product.price * current.quantity
	}, 0)
}

function bundleCost(products, discount = false) {
	var total = totalCost(products)
	if (!discount) return total

	return discountedPrice(total, discount)
}

function discountedPrice(cost, discount) {
	let percentage_value = (100 - discount.percentage_off) / 100.0
	return cost * percentage_value
}

function addItem(product, selected_variant, quantity, products, cart_item = false) {
	//find matching product already selected
	var current_product_index = products.findIndex((item) => item.product.id == product.id)

	if (current_product_index == -1) {
		//not currently innit
		products.push({ product, selected_variant, quantity, cart_item })
	} else {
		products[0].quantity += quantity
	}
}

function submitForm(e) {
	e.preventDefault()

	//change properties of cart items
	var current_cart_properties = e.target.querySelectorAll(".cart-property")

	var fetch_array = Array.from(current_cart_properties).map((el) => {
		// need to make it so that the item is not added just the properties change if it has an item.com underscore item

		var cart_item = el.querySelector("[name='cart_item']")
		var property = el.querySelector("[name='properties']")

		if (!cart_item || !property) return null

		var cart_data = JSON.parse(cart_item.value)
		var prop_value = property.value

		// {
		//   "key": "49275615281441:5cf9e0e77d8ec339fb6a2e8a94993fd2",
		//   "properties": []
		// }

		var data = {
			id: cart_data.key,
			properties: { _bundle: prop_value },
		}

		return fetch(window.Shopify.routes.root + "cart/change.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		}).then((response) => response.json())
	})

	Promise.all(fetch_array)
		.then((responses) => {
			// Handle successful responses

			responses.forEach((response) => {
				// Process each response if needed
			})

			if (!e.target.querySelector('input[name^="items"]')) {
				window.location.href = "/cart"
			} else {
				// Submit the form or perform other actions
				e.target.submit()
			}
			sessionStorage.removeItem("_x_products")
		})
		.catch((err) => {
			// Handle errors
			console.error(err)
			debugger
		})

	// debugger;

	// fetch(window.Shopify.routes.root + "cart/change.js", {
	//   method: "POST",
	//   headers: {
	//     "Content-Type": "application/json",
	//   },
	//   body: JSON.stringify(form_data[0]),
	// })
	//   .then((data) => data.json())
	//   .then((response) => {
	//     debugger;
	//     e.target.submit();
	//   })
	//   .error((err) => {
	//     debugger;
	//   });
}

function initQB(products, cartProducts) {
	//first clean old cart products

	var item_to_remove = []

	products.forEach((item, i) => {
		if (item.cart_item) {
			item_to_remove.push(i)
		}
	})

	item_to_remove.forEach((i) => products.splice(i, 1))

	cartProducts.forEach((item) => {
		addItem(item.product, item.selected_variant, item.quantity, products, item.cart_item)
	})
}

//https://gist.github.com/james0r/e5a02db44beba8b5fc447e78615c1eb7
document.addEventListener("alpine:init", () => {
	Alpine.magic("money", (el, { Alpine }) => {
		return (cents, format) => {
			if (format) {
				format = "${{" + format + "}}"
			}

			if (typeof cents == "string") {
				cents = cents.replace(".", "")
			}
			var value = ""
			var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
			var formatString = format || "${{amount_no_decimals}}"

			function defaultOption(opt, def) {
				return typeof opt == "undefined" ? def : opt
			}

			function formatWithDelimiters(number, precision, thousands, decimal) {
				precision = defaultOption(precision, 2)
				thousands = defaultOption(thousands, ",")
				decimal = defaultOption(decimal, ".")

				if (isNaN(number) || number == null) {
					return 0
				}

				number = (number / 100.0).toFixed(precision)

				var parts = number.split("."),
					dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
					cents = parts[1] ? decimal + parts[1] : ""

				return dollars + cents
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case "amount":
					value = formatWithDelimiters(cents, 2)
					break
				case "amount_no_decimals":
					value = formatWithDelimiters(cents, 0)
					break
				case "amount_with_comma_separator":
					value = formatWithDelimiters(cents, 2, ".", ",")
					break
				case "amount_no_decimals_with_comma_separator":
					value = formatWithDelimiters(cents, 0, ".", ",")
					break
			}

			return formatString.replace(placeholderRegex, value)
		}
	})
})
